import { Box, Card, CardContent, IconButton,InputAdornment, TextField, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { countWords } from '@/features/Functions/ResultFunctions';

interface StreamingResponseCardProps {
  streamingResponse: string;
  placeholderText: string;
}

const StreamingResponseCard: React.FC<StreamingResponseCardProps> = ({ streamingResponse,placeholderText }) => {
  return (
    <Card sx={{ mb: '1rem', height: '95%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', height: '100%' }}>

        {/* Word Count - Always Fixed on Top */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.7rem',
        }}>
          <Tooltip title={<FormattedMessage id="home.text-generator.Result.wordcount" />} arrow>
            <Typography variant="body2" color="textSecondary" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
              {countWords(streamingResponse.toString())} <FormattedMessage id="home.text-generator.Result.word" />
            </Typography>
          </Tooltip>
        </Box>

        {/* Streaming Response Field */}
        <TextField
          placeholder={placeholderText}
          value={streamingResponse}
          multiline
          fullWidth
          rows={15} // Default to 15 rows if not provided
          variant="standard"
          InputProps={{
            disableUnderline: true,

          }}
        />
      </CardContent>
    </Card>

  );
};

export default StreamingResponseCard;
